import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-skeleton-profile',
  templateUrl: './skeleton-profile.component.html',
  styleUrls: ['./skeleton-profile.component.scss']
})
export class SkeletonProfileComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
